// libs
import React, { memo } from 'react';

// styles
import { Container, Action } from './styles';

// defs
export interface ToastProps {
  message: string;
  actionText?: string;
  onActionClick?: VoidFunction;
  onToastHide?: VoidFunction;
  animationTimeMilliSeconds?: number;
  className?: string;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

function Toast({
  message,
  actionText,
  onActionClick = EMPTY_FUNC,
  onToastHide = EMPTY_FUNC,
  animationTimeMilliSeconds = 5000,
  className = '',
}: ToastProps) {
  const animationTime = animationTimeMilliSeconds / 1000;

  return (
    <Container
      className={className}
      onAnimationEnd={onToastHide}
      animationTime={animationTime}
      data-test="toast-container"
    >
      {message}
      {actionText !== undefined && (
        <Action onClick={onActionClick} data-test="toast-action">
          {actionText}
        </Action>
      )}
    </Container>
  );
}

export default memo(Toast);
